// Utilidades para validação recursiva de widgets object e object_list
// Formatos:
// - validateObjectFields retorna um objeto simples { campo: erro }
//   onde erro pode ser string, array ou outro objeto, conforme FormValidation.
// - validateObjectListItems retorna arrayMessage (primeiro elemento é mensagem)
//   com propriedade .internalErrors = { '@idItem': { campo: erro, ... } }
// Ambas não sabem da i18n; mensagem é passada como parâmetro para manter desacoplado.

import FormValidation from '@plone/volto/helpers/FormValidation/FormValidation';
import isObject from 'lodash/isObject';

// Valida um objeto baseado em schema (não encapsula em array)
export function validateObjectFields({
  schema,
  data,
  formatMessage,
  schemaExtender,
}) {
  if (!isObject(data) || !schema?.properties) return {};
  let s = schema;
  if (typeof schemaExtender === 'function') {
    s = schemaExtender(schema, data, formatMessage);
  }
  if (!s?.properties) return {};

  const fieldErrors = FormValidation.validateFieldsPerFieldset({
    schema: s,
    formData: data,
    formatMessage,
  });

  // Descendo para children object/object_list
  Object.entries(s.properties).forEach(([propName, propSchema]) => {
    const value = data?.[propName];
    if (value === undefined || value === null) return;
    if (
      propSchema?.widget === 'object' &&
      propSchema?.schema &&
      isObject(value)
    ) {
      const nested = validateObjectFields({
        schema: propSchema.schema,
        data: value,
        formatMessage,
        schemaExtender: propSchema.schemaExtender,
      });
      if (Object.keys(nested).length) fieldErrors[propName] = nested;
    }
    if (
      propSchema?.widget === 'object_list' &&
      Array.isArray(value) &&
      propSchema?.schema
    ) {
      const nestedList = validateObjectListItems({
        schema: propSchema.schema,
        list: value,
        formatMessage,
        schemaExtender: propSchema.schemaExtender,
        message: formatMessage({
          id: 'Nested list errors',
          defaultMessage: 'Nested list errors',
        }),
      });
      if (nestedList?.internalErrors) fieldErrors[propName] = nestedList;
    }
  });

  return fieldErrors;
}

// Valida uma lista de objetos
export function validateObjectListItems({
  schema,
  list,
  formatMessage,
  schemaExtender,
  message,
}) {
  if (!Array.isArray(list) || !schema) return null;

  const collected = list.reduce((acc, item) => {
    const fid = item['@id'];
    if (!isObject(item)) return acc;
    const itemErrors = validateObjectFields({
      schema,
      data: item,
      formatMessage,
      schemaExtender,
    });
    if (Object.keys(itemErrors).length && fid) acc[fid] = itemErrors;
    return acc;
  }, {});

  if (!Object.keys(collected).length) return null;
  const arr = [message];
  arr.internalErrors = collected;
  return arr;
}
